import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "emprenovus_access_token";

export const tokenStore = {
    get() {
        try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
    },
    set(t) {
        try { if (t) localStorage.setItem(TOKEN_KEY, t); } catch { /* ignore */ }
    },
    clear() {
        try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
    },
};

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach Authorization header from localStorage as a fallback for browsers
// (mainly Safari/iOS) that block third-party cookies set by the backend
// when the deployed domain doesn't match the API origin under ITP rules.
api.interceptors.request.use((config) => {
    const token = tokenStore.get();
    if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Algo salió mal. Intenta nuevamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
